import { useState, useEffect } from 'react';
import Sidebar from '../components/Sidebar';
import ReelPlayerComponent from '../components/ReelPlayerComponent';
import { api } from '../hooks/useAuth';

export default function ReelPlayer() {
  const [reels, setReels] = useState([]);
  const [loading, setLoading] = useState(true);
  const [cartToast, setCartToast] = useState(null);

  useEffect(() => {
    api.get('/api/auth/facebook/reels/saved')
      .then(({ data }) => setReels(data.reels || []))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  const handleAddToCart = async (product) => {
    // In production: call Shopify Cart API
    console.log('Add to cart:', product);
    setCartToast(`Added "${product.product_title}" to cart!`);
    setTimeout(() => setCartToast(null), 3000);
  };

  const handleBuyNow = (product) => {
    console.log('Buy now:', product);
    // In production: redirect to Shopify checkout
    alert(`Redirecting to checkout for: ${product.product_title}`);
  };

  return (
    <div className="app-layout">
      <Sidebar />
      <main className="main-content">
        <div className="page-header">
          <div>
            <h1 className="page-title">Player Preview</h1>
            <p className="page-subtitle">
              This is how your shoppable reels will appear on your website
            </p>
          </div>
          <div style={{ display: 'flex', gap: 10 }}>
            <span className="badge badge-cyan">↑ ↓ to navigate</span>
            <span className="badge badge-purple">M to mute</span>
            <span className="badge badge-success">Space to pause</span>
          </div>
        </div>

        {/* Cart toast */}
        {cartToast && (
          <div className="alert alert-success" style={{
            position: 'fixed', bottom: 32, right: 32, zIndex: 9999,
            animation: 'slideUp 0.3s ease', minWidth: 280,
          }}>
            🛒 {cartToast}
          </div>
        )}

        <div style={{ display: 'flex', gap: 48, alignItems: 'flex-start' }}>
          {/* Player */}
          <div>
            {loading ? (
              <div className="loading-screen" style={{ width: 390 }}>
                <span className="spinner" />
                Loading reels...
              </div>
            ) : (
              <ReelPlayerComponent
                reels={reels}
                onAddToCart={handleAddToCart}
                onBuyNow={handleBuyNow}
              />
            )}
          </div>

          {/* Info Panel */}
          <div style={{ flex: 1, maxWidth: 400 }}>
            <div className="card" style={{ marginBottom: 16 }}>
              <h3 style={{ fontSize: 15, fontWeight: 700, marginBottom: 12 }}>Player Controls</h3>
              <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
                {[
                  ['↑ / K', 'Previous reel'],
                  ['↓ / J', 'Next reel'],
                  ['Space', 'Play / Pause'],
                  ['M', 'Mute / Unmute'],
                  ['Swipe', 'Navigate reels (mobile)'],
                ].map(([key, desc]) => (
                  <div key={key} style={{ display: 'flex', justifyContent: 'space-between', fontSize: 13 }}>
                    <kbd style={{
                      background: 'var(--bg3)', border: '1px solid var(--border)',
                      borderRadius: 6, padding: '2px 8px', fontFamily: 'monospace',
                      fontSize: 12, color: 'var(--accent3)',
                    }}>{key}</kbd>
                    <span style={{ color: 'var(--text-dim)' }}>{desc}</span>
                  </div>
                ))}
              </div>
            </div>

            <div className="card" style={{ marginBottom: 16 }}>
              <h3 style={{ fontSize: 15, fontWeight: 700, marginBottom: 12 }}>Reel Info</h3>
              <p style={{ fontSize: 13, color: 'var(--text-dim)' }}>
                {reels.length} reel{reels.length !== 1 ? 's' : ''} loaded
              </p>
              {reels.length === 0 && (
                <p style={{ fontSize: 13, color: 'var(--text-dim)', marginTop: 8 }}>
                  Go to <a href="/reels" style={{ color: 'var(--accent)' }}>Reel Manager</a> to sync reels from Instagram first.
                </p>
              )}
            </div>

          </div>
        </div>
      </main>
    </div>
  );
}
